import React from "react";
import { node } from "prop-types";
import { Col, Row } from "../Grid";

const SimpleTemplateForm = ({ children }) => {
	return (
		<Row utility={{ justify: "center" }}>
			<Col md={8}>{children}</Col>
		</Row>
	);
};

SimpleTemplateForm.propTypes = {
	children: node.isRequired,
};

export default SimpleTemplateForm;
